import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
// import logoImage from "./winnerimg.jpg";
import { ImExit } from "react-icons/im";
import { FaLock } from "react-icons/fa6";
import { FaCheckCircle } from "react-icons/fa";
import { winsound } from '../../chimes';
import { winsound2 } from '../../chimes';
import { notwinsound } from '../../chimes';
import { notwinsound2 } from '../../chimes';
import { newtonsCradle } from 'ldrs'

newtonsCradle.register()

// Default values shown



const CartelaModal = ({ calledBalls, onClose,onReset, betAmount, cardCount, totalAmount, selectedCards, manualEnteredCut, manualCut, selectedPattern ,selectedPattern2, selectedCaller, lastCalledBall }) => {
  const [cartelaId, setCartelaId] = useState('');
  const [cartela, setCartela] = useState(null);
  const [matchedNumbers, setMatchedNumbers] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [fetchError, setFetchError] = useState(null);
  const [isBingo, setIsBingo] = useState(false);
  const [bingoNumbers, setBingoNumbers] = useState([]);
  const [winnerCards, setWinnerCards] = useState([]);
  const [lockedCards, setLockedCards] = useState([]);
  const [isRefunded, setIsRefunded] = useState(false);
  const { currentUser } = useSelector((state) => state.user);
  // Dynamic audio refs based on selected caller
  const getWinSound = () => {
    return selectedCaller && selectedCaller.value === 'arada2' ? winsound : winsound2;
  };
  
  const getNotWinSound = () => {
    return selectedCaller && selectedCaller.value === 'arada2' ? notwinsound : notwinsound2;
  };
  
  const audioRef = useRef(null);
  const notWinAudioRef = useRef(null);
  
  // Initialize audio refs when component mounts or selectedCaller changes
  useEffect(() => {
    // Frontend memory monitoring for CartelaModal
    console.log('🏆 CartelaModal mounted - Audio initialization');
    if (performance.memory) {
      const memory = performance.memory;
      const usedMB = (memory.usedJSHeapSize / 1024 / 1024).toFixed(2);
      console.log(`📊 CartelaModal Memory: ${usedMB} MB used`);
    }
    
    // Initialize audio refs
    audioRef.current = new Audio(getWinSound());
    notWinAudioRef.current = new Audio(getNotWinSound());
    
    // Cleanup function to prevent memory leaks
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = '';
        audioRef.current = null;
      }
      if (notWinAudioRef.current) {
        notWinAudioRef.current.pause();
        notWinAudioRef.current.src = '';
        notWinAudioRef.current = null;
      }
    };
  }, [selectedCaller]);
  const inputRef = useRef(null);
  useEffect(() => {
    const storedLockedCards = JSON.parse(localStorage.getItem('lockedCards')) || [];
    setLockedCards(storedLockedCards);
  }, []);
  useEffect(() => {
    // Focus on the input field when the component mounts
    inputRef.current.focus();
  }, []);

  const fetchCartela = async () => {
    const cartelaIdNumber = Number(cartelaId);
    if (!selectedCards.includes(cartelaIdNumber)) {
      alert('Cartela ID is not in the selected cards');
      return;
    }
    if (lockedCards.includes(cartelaIdNumber)) {
      alert('This card is locked and cannot be checked again 😭😭.');
      return;
    }
    setIsFetching(true);
    setFetchError(null);
    try {
      const response = await fetch(`/api/card/cartela/${currentUser.branch}/${cartelaId}`, {
        method: 'GET',
      });
      if (!response.ok) {
        throw new Error('Failed to fetch cartela');
      }
      const data = await response.json();
      setCartela(data);
    } catch (error) {
      setFetchError(error.message);
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    if (cartela && cartela.length > 0) {
      checkCartelaNumbers(cartela[0]);
    }
  }, [cartela, calledBalls]);

  const checkCartelaNumbers = (cartela) => {
    if (cartela && cartela.card) {
      const allNumbers = Object.values(cartela.card).flat();
      const matched = calledBalls.filter((call) => allNumbers.includes(call.number));
      const freeSpace = { number: "Free", column: "N", index: 2 };
      matched.push(freeSpace);
      setMatchedNumbers(matched);
      checkBingo(cartela.card, matched);
    }
  };

  // Utility: compare two arrays as sets to detect pattern changes in winning lines
  const arraysEqualAsSets = (a = [], b = []) => {
    if (!a || !b) return false;
    if (a.length !== b.length) return false;
    const sa = new Set(a);
    const sb = new Set(b);
    if (sa.size !== sb.size) return false;
    for (const v of sa) {
      if (!sb.has(v)) return false;
    }
    return true;
  };

  const checkBingo = (card, matched) => {
    // Guard against missing pattern selections
    if (!selectedPattern || !selectedPattern2 || !selectedPattern.value || !selectedPattern2.value) {
      return;
    }
    // --- Helper Functions for 'Any Three Lines' Pattern ---
    const getNumberFromIndex = (card, index) => {
        if (index === 12) return 'Free';
        const colMap = ['B', 'I', 'N', 'G', 'O'];
        const col = colMap[index % 5];
        const row = Math.floor(index / 5);
        return card[col][row];
    };

    const checkAnyThreeLines = () => {
      const allLines = [
        // Horizontal lines
        [0, 1, 2, 3, 4], [5, 6, 7, 8, 9], [10, 11, 12, 13, 14], [15, 16, 17, 18, 19], [20, 21, 22, 23, 24],
        // Vertical lines
        [0, 5, 10, 15, 20], [1, 6, 11, 16, 21], [2, 7, 12, 17, 22], [3, 8, 13, 18, 23], [4, 9, 14, 19, 24],
        // Diagonal lines
        [0, 6, 12, 18, 24], [4, 8, 12, 16, 20]
      ];

      let completedLines = [];
      for (const line of allLines) {
        const isLineComplete = line.every(index => {
          const number = getNumberFromIndex(card, index);
          return number === 'Free' || matched.some(m => m.number === number);
        });
        if (isLineComplete) {
          completedLines.push(line);
        }
      }

      if (completedLines.length >= 3) {
        const winningPattern = new Set();
        // Collect all indices from the first three completed lines
        for (let i = 0; i < 3; i++) {
          completedLines[i].forEach(index => {
            const number = getNumberFromIndex(card, index);
            if (number !== 'Free') {
              winningPattern.add(number);
            }
          });
        }
        return { isBingo: true, pattern: winningPattern };
      }
      return { isBingo: false, pattern: new Set() };
    };

    const rows = [...Array(5)].map((_, i) => Object.keys(card).map(col => card[col][i]));
    const columns = Object.values(card);
    const diagonals = [
      [card.B[0], card.I[1], "Free", card.G[3], card.O[4]], // Main diagonal
      [card.O[0], card.G[1], "Free", card.I[3], card.B[4]] ,

    
    ];
   
    

    const lines = [...rows, ...columns, ...diagonals]; 
 
    let bingoLine = null;
  
    const isWinningPattern = (line) => {
      return line.every(num => matched.some(call => call.number === num || num === "Free"));
    };
    const letterA = [
      [card.B[0],card.B[1], card.B[2],card.B[3],card.B[4],card.I[2],  card.B[4], 
      card.O[0], card.I[0],card.N[0],  card.G[0], card.O[3], card.O[2], card.O[1],  card.O[4],card.N[2],card.G[2],   ], //a
  
      [card.B[0], card.B[1],  card.B[4], card.B[3],card.B[2],
      card.O[0],  card.O[3], card.O[2], card.O[1],  card.O[4],card.I[2],card.N[2],card.G[2],   ], //H
  
      [card.B[0], card.B[1],  card.B[4], card.B[3],card.B[2],
       card.I[0],card.N[0],  card.G[0], card.O[3], card.O[2], card.O[1],  card.I[4],card.N[4],card.G[4]], //D
      
       [card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
       card.O[0],  card.O[3], card.O[2], card.O[1],  card.O[4],card.I[4],card.N[4],card.G[4],   ], //U
      
  ];

 



const Mark=[

  
      [card.B[0], card.B[1],  card.B[4], card.B[3],card.B[2],
      card.O[0],  card.O[3], card.O[2], card.O[1],  card.O[4],
      card.I[0],card.N[0],card.G[0],  card.I[4],card.N[4],card.G[4], ],
];








const AOS=[
  [card.B[0],  card.B[1], 
  card.I[0],   card.I[1]], 

  [card.B[3],  card.B[4], 
  card.I[3],   card.I[4]], 

  [card.G[0],  card.G[1], 
  card.O[0],   card.O[1]], 

  [card.G[3],  card.G[4], 
  card.O[3],   card.O[4]], 
 
  
];
const ATS=[
  [card.B[0],  card.B[1], 
  card.I[0],   card.I[1],card.B[3],  card.B[4], 
  card.I[3],   card.I[4]], 

  [card.B[0],  card.B[1], 
  card.I[0],   card.I[1],card.G[0],  card.G[1], 
  card.O[0],   card.O[1]], 

  [card.B[0],  card.B[1], 
  card.I[0],   card.I[1],card.G[3],  card.G[4], 
  card.O[3],   card.O[4]], 

  [card.B[3],  card.B[4], 
  card.I[3],   card.I[4],card.G[0],  card.G[1], 
  card.O[0],   card.O[1]],

  [card.B[3],  card.B[4], 
  card.I[3],   card.I[4],card.G[3],  card.G[4], 
  card.O[3],   card.O[4]], 

  [card.G[0],  card.G[1], 
  card.O[0],   card.O[1],card.G[3],  card.G[4], 
  card.O[3],   card.O[4]], 

];

const lines2 = [   
  [card.B[0], card.I[1], "Free", card.G[3], card.O[4]], 
[card.O[0], card.G[1], "Free", card.I[3], card.B[4]] ,
[ card.I[1],card.I[3], card.G[1], card.G[3]],  
[card.B[0],  card.B[4], card.O[0],   card.O[4]],

[card.B[0],card.B[1],card.B[2],card.B[3],card.B[4]],
[card.I[0],card.I[1],card.I[2],card.I[3],card.I[4]],
[card.N[0],card.N[1],card.N[2],card.N[3],card.N[4]],
[card.G[0],card.G[1],card.G[2],card.G[3],card.G[4]],
[card.O[0],card.O[1],card.O[2],card.O[3],card.O[4]],


[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0]],
[card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1]],
[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2]],
[card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3]],
[card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4]],

];


//anydia
const lines3 = [   
[card.B[0], card.I[1], "Free", card.G[3], card.O[4]
,card.O[0], card.G[1], "Free", card.I[3], card.B[4]],


[ card.I[1],card.I[3], card.G[1], card.G[3],card.B[0], card.I[1], "Free", card.G[3], card.O[4]],  
[card.B[0],  card.B[4], card.O[0],   card.O[4],card.B[0], card.I[1], "Free", card.G[3], card.O[4]],

[ card.I[1],card.I[3], card.G[1], card.G[3],card.O[0], card.G[1], "Free", card.I[3], card.B[4]],  
[card.B[0],  card.B[4], card.O[0],   card.O[4],card.O[0], card.G[1], "Free", card.I[3], card.B[4],],

[card.B[0],card.B[1],card.B[2],card.B[3],card.B[4],card.B[0], card.I[1], "Free", card.G[3], card.O[4]],
[card.I[0],card.I[1],card.I[2],card.I[3],card.I[4],card.B[0], card.I[1], "Free", card.G[3], card.O[4]],
[card.N[0],card.N[1],card.N[2],card.N[3],card.N[4],card.B[0], card.I[1], "Free", card.G[3], card.O[4]],
[card.G[0],card.G[1],card.G[2],card.G[3],card.G[4],card.B[0], card.I[1], "Free", card.G[3], card.O[4]],
[card.O[0],card.O[1],card.O[2],card.O[3],card.O[4],card.B[0], card.I[1], "Free", card.G[3], card.O[4]],

[card.B[0],card.B[1],card.B[2],card.B[3],card.B[4],card.O[0], card.G[1], "Free", card.I[3], card.B[4]],
[card.I[0],card.I[1],card.I[2],card.I[3],card.I[4],card.O[0], card.G[1], "Free", card.I[3], card.B[4]],
[card.N[0],card.N[1],card.N[2],card.N[3],card.N[4],card.O[0], card.G[1], "Free", card.I[3], card.B[4]],
[card.G[0],card.G[1],card.G[2],card.G[3],card.G[4],card.O[0], card.G[1], "Free", card.I[3], card.B[4]],
[card.O[0],card.O[1],card.O[2],card.O[3],card.O[4],card.O[0], card.G[1], "Free", card.I[3], card.B[4]],


[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],card.O[0], card.G[1], "Free", card.I[3], card.B[4]],
[card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],card.O[0], card.G[1], "Free", card.I[3], card.B[4]],
[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],card.O[0], card.G[1], "Free", card.I[3], card.B[4]],
[card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],card.O[0], card.G[1], "Free", card.I[3], card.B[4]],
[card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],card.O[0], card.G[1], "Free", card.I[3], card.B[4]],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],card.B[0], card.I[1], "Free", card.G[3], card.O[4]],
[card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],card.B[0], card.I[1], "Free", card.G[3], card.O[4]],
[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],card.B[0], card.I[1], "Free", card.G[3], card.O[4]],
[card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],card.B[0], card.I[1], "Free", card.G[3], card.O[4]],
[card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],card.B[0], card.I[1], "Free", card.G[3], card.O[4]],

];



//anyver
const lines4 = [   
[card.B[0], card.I[1], "Free", card.G[3], card.O[4],card.B[0],card.B[1],card.B[2],card.B[3],card.B[4]], 
[card.B[0], card.I[1], "Free", card.G[3], card.O[4],card.I[0],card.I[1],card.I[2],card.I[3],card.I[4]], 
[card.B[0], card.I[1], "Free", card.G[3], card.O[4],card.N[0],card.N[1],card.N[2],card.N[3],card.N[4]], 
[card.B[0], card.I[1], "Free", card.G[3], card.O[4],card.G[0],card.G[1],card.G[2],card.G[3],card.G[4]], 
[card.B[0], card.I[1], "Free", card.G[3], card.O[4],card.O[0],card.O[1],card.O[2],card.O[3],card.O[4]], 

[card.O[0], card.G[1], "Free", card.I[3], card.B[4],card.B[0],card.B[1],card.B[2],card.B[3],card.B[4]], 
[card.O[0], card.G[1], "Free", card.I[3], card.B[4],card.I[0],card.I[1],card.I[2],card.I[3],card.I[4]], 
[card.O[0], card.G[1], "Free", card.I[3], card.B[4],card.N[0],card.N[1],card.N[2],card.N[3],card.N[4]], 
[card.O[0], card.G[1], "Free", card.I[3], card.B[4],card.G[0],card.G[1],card.G[2],card.G[3],card.G[4]], 
[card.O[0], card.G[1], "Free", card.I[3], card.B[4],card.O[0],card.O[1],card.O[2],card.O[3],card.O[4]], 

[ card.I[1],card.I[3], card.G[1], card.G[3],card.B[0],card.B[1],card.B[2],card.B[3],card.B[4]],  
[ card.I[1],card.I[3], card.G[1], card.G[3],card.I[0],card.I[1],card.I[2],card.I[3],card.I[4]],  
[ card.I[1],card.I[3], card.G[1], card.G[3],card.N[0],card.N[1],card.N[2],card.N[3],card.N[4]],  
[ card.I[1],card.I[3], card.G[1], card.G[3],card.G[0],card.G[1],card.G[2],card.G[3],card.G[4]],  
[ card.I[1],card.I[3], card.G[1], card.G[3],card.O[0],card.O[1],card.O[2],card.O[3],card.O[4]], 

[card.B[0],  card.B[4], card.O[0],   card.O[4],card.B[0],card.B[1],card.B[2],card.B[3],card.B[4]],  
[card.B[0],  card.B[4], card.O[0],   card.O[4],card.I[0],card.I[1],card.I[2],card.I[3],card.I[4]],  
[card.B[0],  card.B[4], card.O[0],   card.O[4],card.N[0],card.N[1],card.N[2],card.N[3],card.N[4]],  
[card.B[0],  card.B[4], card.O[0],   card.O[4],card.G[0],card.G[1],card.G[2],card.G[3],card.G[4]],  
[card.B[0],  card.B[4], card.O[0],   card.O[4],card.O[0],card.O[1],card.O[2],card.O[3],card.O[4]],  


[card.B[0],card.B[1],card.B[2],card.B[3],card.B[4]],
[card.I[0],card.I[1],card.I[2],card.I[3],card.I[4]],
[card.N[0],card.N[1],card.N[2],card.N[3],card.N[4]],
[card.G[0],card.G[1],card.G[2],card.G[3],card.G[4]],
[card.O[0],card.O[1],card.O[2],card.O[3],card.O[4]],


[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],card.B[0],card.B[1],card.B[2],card.B[3],card.B[4]],
[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],card.I[0],card.I[1],card.I[2],card.I[3],card.I[4]],
[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],card.N[0],card.N[1],card.N[2],card.N[3],card.N[4]],
[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],card.G[0],card.G[1],card.G[2],card.G[3],card.G[4]],
[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],card.O[0],card.O[1],card.O[2],card.O[3],card.O[4]],


[card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],card.B[0],card.B[1],card.B[2],card.B[3],card.B[4]],
[card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],card.I[0],card.I[1],card.I[2],card.I[3],card.I[4]],
[card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],card.N[0],card.N[1],card.N[2],card.N[3],card.N[4]],
[card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],card.G[0],card.G[1],card.G[2],card.G[3],card.G[4]],
[card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],card.O[0],card.O[1],card.O[2],card.O[3],card.O[4]],

[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],card.B[0],card.B[1],card.B[2],card.B[3],card.B[4]],
[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],card.I[0],card.I[1],card.I[2],card.I[3],card.I[4]],
[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],card.N[0],card.N[1],card.N[2],card.N[3],card.N[4]],
[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],card.G[0],card.G[1],card.G[2],card.G[3],card.G[4]],
[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],card.O[0],card.O[1],card.O[2],card.O[3],card.O[4]],


[card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],card.B[0],card.B[1],card.B[2],card.B[3],card.B[4]],
[card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],card.I[0],card.I[1],card.I[2],card.I[3],card.I[4]],
[card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],card.N[0],card.N[1],card.N[2],card.N[3],card.N[4]],
[card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],card.G[0],card.G[1],card.G[2],card.G[3],card.G[4]],
[card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],card.O[0],card.O[1],card.O[2],card.O[3],card.O[4]],

[card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],card.B[0],card.B[1],card.B[2],card.B[3],card.B[4]],
[card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],card.I[0],card.I[1],card.I[2],card.I[3],card.I[4]],
[card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],card.N[0],card.N[1],card.N[2],card.N[3],card.N[4]],
[card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],card.G[0],card.G[1],card.G[2],card.G[3],card.G[4]],
[card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],card.O[0],card.O[1],card.O[2],card.O[3],card.O[4]],

];

//anyhor
const lines5 = [   
[card.B[0], card.I[1], "Free", card.G[3], card.O[4],card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0]], 
[card.B[0], card.I[1], "Free", card.G[3], card.O[4],card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1]], 
[card.B[0], card.I[1], "Free", card.G[3], card.O[4],card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2]], 
[card.B[0], card.I[1], "Free", card.G[3], card.O[4],card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3]], 
[card.B[0], card.I[1], "Free", card.G[3], card.O[4],card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4]],

[card.O[0], card.G[1], "Free", card.I[3], card.B[4],card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0]], 
[card.O[0], card.G[1], "Free", card.I[3], card.B[4],card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1]], 
[card.O[0], card.G[1], "Free", card.I[3], card.B[4],card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2]], 
[card.O[0], card.G[1], "Free", card.I[3], card.B[4],card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3]], 
[card.O[0], card.G[1], "Free", card.I[3], card.B[4],card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4]], 

[ card.I[1],card.I[3], card.G[1], card.G[3],card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0]],  
[ card.I[1],card.I[3], card.G[1], card.G[3],card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1]],  
[ card.I[1],card.I[3], card.G[1], card.G[3],card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2]],  
[ card.I[1],card.I[3], card.G[1], card.G[3],card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3]],  
[ card.I[1],card.I[3], card.G[1], card.G[3],card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4]],

[ card.B[0],  card.B[4], card.O[0],   card.O[4],card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0]],  
[ card.B[0],  card.B[4], card.O[0],   card.O[4],card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1]],  
[ card.B[0],  card.B[4], card.O[0],   card.O[4],card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2]],  
[ card.B[0],  card.B[4], card.O[0],   card.O[4],card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3]],  
[ card.B[0],  card.B[4], card.O[0],   card.O[4],card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4]],  


[card.B[0],card.B[1],card.B[2],card.B[3],card.B[4],card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0]],
[card.B[0],card.B[1],card.B[2],card.B[3],card.B[4],card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1]],
[card.B[0],card.B[1],card.B[2],card.B[3],card.B[4],card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2]],
[card.B[0],card.B[1],card.B[2],card.B[3],card.B[4],card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3]],
[card.B[0],card.B[1],card.B[2],card.B[3],card.B[4],card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4]],

[card.I[0],card.I[1],card.I[2],card.I[3],card.I[4],card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0]],
[card.I[0],card.I[1],card.I[2],card.I[3],card.I[4],card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1]],
[card.I[0],card.I[1],card.I[2],card.I[3],card.I[4],card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2]],
[card.I[0],card.I[1],card.I[2],card.I[3],card.I[4],card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3]],
[card.I[0],card.I[1],card.I[2],card.I[3],card.I[4],card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4]],

[card.N[0],card.N[1],card.N[2],card.N[3],card.N[4],card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0]],
[card.N[0],card.N[1],card.N[2],card.N[3],card.N[4],card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1]],
[card.N[0],card.N[1],card.N[2],card.N[3],card.N[4],card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2]],
[card.N[0],card.N[1],card.N[2],card.N[3],card.N[4],card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3]],
[card.N[0],card.N[1],card.N[2],card.N[3],card.N[4],card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4]],

[card.G[0],card.G[1],card.G[2],card.G[3],card.G[4],card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0]],
[card.G[0],card.G[1],card.G[2],card.G[3],card.G[4],card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1]],
[card.G[0],card.G[1],card.G[2],card.G[3],card.G[4],card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2]],
[card.G[0],card.G[1],card.G[2],card.G[3],card.G[4],card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3]],
[card.G[0],card.G[1],card.G[2],card.G[3],card.G[4],card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4]],

[card.O[0],card.O[1],card.O[2],card.O[3],card.O[4],card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0]],
[card.O[0],card.O[1],card.O[2],card.O[3],card.O[4],card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1]],
[card.O[0],card.O[1],card.O[2],card.O[3],card.O[4],card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2]],
[card.O[0],card.O[1],card.O[2],card.O[3],card.O[4],card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3]],
[card.O[0],card.O[1],card.O[2],card.O[3],card.O[4],card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4]],


[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0]],
[card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1]],
[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2]],
[card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3]],
[card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4]],

];
















const Mark2=[
  [card.B[0], card.B[1],  card.B[4], card.B[3],card.B[2],
  card.O[0],  card.O[3], card.O[2], card.O[1],  card.O[4],
  card.I[0],card.N[0],card.G[0],  card.I[4],card.N[4],card.G[4], ],
  
];







  const FMCC = [
    [card.B[0], card.I[1],  card.B[4], card.I[3],card.G[1],
    card.O[0], card.G[3],  card.O[4]], 
    
];

const MS4 = [
  [ card.I[1],   card.I[3],card.G[1],
  card.G[3]], 
  
];

const CS4 = [
  [card.B[0],  card.B[4], 
  card.O[0],   card.O[4]], 
  
];
const FH = [
  [card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],], 
  
];
  const ATH = [
    [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
    card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2]],

    [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
    card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1]], 

    [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
    card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3]], 

    [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
    card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4]], 

    [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
    card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1]], 

    [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
    card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1]], 

    [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
    card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1]], 

    [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
    card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3]], 

    [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
    card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4]], 

    [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
    card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4]], 


];

const ATV = [
  [card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]], 

  [card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4]], 

  [card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4]], 

  [card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]], 
  
  [ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]], 
  
  [  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]], 

  [ card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]], 

  [ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],], 

  [ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]], 

  [ card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]], 
];

const ATL = [
  [card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]], 

  [card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4]], 

  [card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4], 
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4]], 

  [card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]], 
  
  [ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]], 
  
  [  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]], 

  [ card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]], 

  [ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],], 

  [ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]], 

  [ card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]], 

  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
    card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2]],

    [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
    card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1]], 

    [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
    card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3]], 

    [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
    card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4]], 

    [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
    card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1]], 

    [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
    card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1]], 

    [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
    card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1]], 

    [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
    card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3]], 

    [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
    card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4]], 

    [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
    card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4]], 

    [card.B[0], card.I[1], "Free", card.G[3], card.O[4],
  card.O[0], card.G[1], "Free", card.I[3], card.B[4]],

  [card.N[0], card.N[1], "Free", card.N[3], card.N[4],
  card.O[2], card.G[2], "Free", card.I[2], card.B[2]],

  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4]],

  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]],
  
  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]],

  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]],

  [card.B[0], card.I[1],  card.N[2], card.G[3],card.O[4],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]],

  [card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4]],

  [card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4]],

  [card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4]],

  [card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4]],

  [card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4]],

  [card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.B[4], card.I[3], "Free", card.G[1], card.O[0]],

  [card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
  card.B[4], card.I[3], "Free", card.G[1], card.O[0]],

  [card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
  card.B[4], card.I[3], "Free", card.G[1], card.O[0]],

  [card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4],
  card.B[4], card.I[3], "Free", card.G[1], card.O[0]],

  [card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
  card.B[4], card.I[3], "Free", card.G[1], card.O[0]],



  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.B[4], card.I[3], "Free", card.G[1], card.O[0]],

  [card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.B[4], card.I[3], "Free", card.G[1], card.O[0]],

  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[4], card.I[3], "Free", card.G[1], card.O[0]],

  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[4], card.I[3], "Free", card.G[1], card.O[0]],

  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[4], card.I[3], "Free", card.G[1], card.O[0]],


  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4]],

  [card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4]],

  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4]],

  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4]],

  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4]],

  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.N[0], card.N[1], "Free", card.N[3], card.N[4]],

  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.N[0], card.N[1], "Free", card.N[3], card.N[4]],

  [card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.N[0], card.N[1], "Free", card.N[3], card.N[4]],

  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.N[0], card.N[1], "Free", card.N[3], card.N[4]],

  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4]],


  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]],

   
  [card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]],


  [card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4]],

  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4]],

  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4]],

  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4]],

  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4]],

  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]],

  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]],

  [card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]],
  
  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]],

  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]],



  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4]],

  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4]],

  [card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4]],
  
  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4]],

  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4]],

];



const AHORAVER=[
  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4]],

  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]],

  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4]],

  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4]],

  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]],


  [card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4]],

  [card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]],

  [card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4]],

  [card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4]],

  [card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]],


  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4]],

  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]],

  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4]],

  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4]],

  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]],


  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4]],

  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]],

  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4]],

  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4]],

  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]],



  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4]],

  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]],

  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4]],

  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4]],

  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]],
];




const AHORADIA=[
  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.B[0], card.I[1],  card.N[2], card.G[3],card.O[4]],

  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.B[4], card.I[3],  card.N[2], card.G[1],card.O[0]],


  [card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.B[0], card.I[1],  card.N[2], card.G[3],card.O[4]],

  [card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.B[4], card.I[3],  card.N[2], card.G[1],card.O[0]],


  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[0], card.I[1],  card.N[2], card.G[3],card.O[4]],

  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[4], card.I[3],  card.N[2], card.G[1],card.O[0]],


  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[0], card.I[1],  card.N[2], card.G[3],card.O[4]],

  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[4], card.I[3],  card.N[2], card.G[1],card.O[0]],


  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[0], card.I[1],  card.N[2], card.G[3],card.O[4]],

  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[4], card.I[3],  card.N[2], card.G[1],card.O[0]],
];


const AHORATV=[
  [card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
  card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],

], 
[card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],

],

[card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
  card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],

],

[card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
  card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],

],

[card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],

],



[card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4],
card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
],

[card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
],


[card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4],
card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
],

[card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
],

  [card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
], 



[card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
],

[card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
],


[card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
],

[card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
],

  [card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
], 



[card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
], 


[card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
], 


[card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
], 

[card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
], 

  [card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
], 



[ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
], 


[ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
], 

[ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
], 

[ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
], 
  
  [ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
], 



  

[  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
  card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
],


[  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
],

[  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
  card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
],

[  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
  card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
],

  [  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
], 



[ card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
], 


[ card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
], 

[ card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
], 

[ card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
], 

  [ card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
], 


[ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
  card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
],

[ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
],

[ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
  card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
],

[ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
  card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
],

  [ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
], 





[ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
], 

[ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
], 

[ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
], 
[ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
], 

  [ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
], 


[ card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
],

[ card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
],

[ card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
],

[ card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
],

  [ card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
],
];

const AHORMS=[
  [ card.I[1],   card.I[3],card.G[1],
  card.G[3],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
],

[ card.I[1],   card.I[3],card.G[1],
card.G[3],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
],

[ card.I[1],   card.I[3],card.G[1],
card.G[3],
card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
],

[ card.I[1],   card.I[3],card.G[1],
card.G[3],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
],

[ card.I[1],   card.I[3],card.G[1],
card.G[3],
card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
],

];


const AHORCS=[
  [card.B[0],  card.B[4], 
  card.O[0],   card.O[4],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
],

[ card.B[0],  card.B[4], 
card.O[0],   card.O[4],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
],

[ card.B[0],  card.B[4], 
card.O[0],   card.O[4],
card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
],

[ card.B[0],  card.B[4], 
card.O[0],   card.O[4],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
],

[ card.B[0],  card.B[4], 
card.O[0],   card.O[4],
card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
],

];

const AHORFMC=[
  [  card.B[0], card.I[1],  card.B[4], card.I[3],card.G[1],
  card.O[0], card.G[3],  card.O[4], 
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
],

[  card.B[0], card.I[1],  card.B[4], card.I[3],card.G[1],
card.O[0], card.G[3],  card.O[4], 
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
],

[  card.B[0], card.I[1],  card.B[4], card.I[3],card.G[1],
card.O[0], card.G[3],  card.O[4], 
card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
],

[  card.B[0], card.I[1],  card.B[4], card.I[3],card.G[1],
card.O[0], card.G[3],  card.O[4], 
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
],

[   card.B[0], card.I[1],  card.B[4], card.I[3],card.G[1],
card.O[0], card.G[3],  card.O[4], 
card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
],

];




// Anyvertical






const AVERADIA=[
  [card.B[0],card.B[1],card.B[2],card.B[3],card.B[4],
  card.B[0], card.I[1],  card.N[2], card.G[3],card.O[4]],

  [card.B[0],card.B[1],card.B[2],card.B[3],card.B[4],
  card.B[4], card.I[3],  card.N[2], card.G[1],card.O[0]],


  [card.I[0],card.I[1],card.I[2],card.I[3],card.I[4],
  card.B[0], card.I[1],  card.N[2], card.G[3],card.O[4]],

  [card.I[0],card.I[1],card.I[2],card.I[3],card.I[4],
  card.B[4], card.I[3],  card.N[2], card.G[1],card.O[0]],


  [card.N[0],card.N[1],card.N[2],card.N[3],card.N[4],
  card.B[0], card.I[1],  card.N[2], card.G[3],card.O[4]],

  [card.N[0],card.N[1],card.N[2],card.N[3],card.N[4],
  card.B[4], card.I[3],  card.N[2], card.G[1],card.O[0]],


  [card.G[0],card.G[1],card.G[2],card.G[3],card.G[4],
  card.B[0], card.I[1],  card.N[2], card.G[3],card.O[4]],

  [card.G[0],card.G[1],card.G[2],card.G[3],card.G[4],
  card.B[4], card.I[3],  card.N[2], card.G[1],card.O[0]],


  [card.O[0],card.O[1],card.O[2],card.O[3],card.O[4],
  card.B[0], card.I[1],  card.N[2], card.G[3],card.O[4]],

  [card.O[0],card.O[1],card.O[2],card.O[3],card.O[4],
  card.B[4], card.I[3],  card.N[2], card.G[1],card.O[0]],
];



const AVERMS=[
  [ card.I[1],   card.I[3],card.G[1],
  card.G[3],
  card.O[0],card.O[1],card.O[2],card.O[3],card.O[4],
],

[ card.I[1],   card.I[3],card.G[1],
card.G[3],
card.G[0],card.G[1],card.G[2],card.G[3],card.G[4],
],

[ card.I[1],   card.I[3],card.G[1],
card.G[3],
card.N[0],card.N[1],card.N[2],card.N[3],card.N[4],
],

[ card.I[1],   card.I[3],card.G[1],
card.G[3],
card.I[0],card.I[1],card.I[2],card.I[3],card.I[4],
],

[ card.I[1],   card.I[3],card.G[1],
card.G[3],
card.B[0],card.B[1],card.B[2],card.B[3],card.B[4],
],

];


const AVERCS=[
  [card.B[0],  card.B[4], 
  card.O[0],   card.O[4],
  card.O[0],card.O[1],card.O[2],card.O[3],card.O[4],
],

[ card.B[0],  card.B[4], 
card.O[0],   card.O[4],
card.I[0],card.I[1],card.I[2],card.I[3],card.I[4],
],

[ card.B[0],  card.B[4], 
card.O[0],   card.O[4],
card.N[0],card.N[1],card.N[2],card.N[3],card.N[4],
],

[ card.B[0],  card.B[4], 
card.O[0],   card.O[4],
card.G[0],card.G[1],card.G[2],card.G[3],card.G[4],
],

[ card.B[0],  card.B[4], 
card.O[0],   card.O[4],
card.B[0],card.B[1],card.B[2],card.B[3],card.B[4],
],

];

const AVERFMC=[
  [  card.B[0], card.I[1],  card.B[4], card.I[3],card.G[1],
  card.O[0], card.G[3],  card.O[4], 
  card.B[0],card.B[1],card.B[2],card.B[3],card.B[4],
],

[  card.B[0], card.I[1],  card.B[4], card.I[3],card.G[1],
card.O[0], card.G[3],  card.O[4], 
card.I[0],card.I[1],card.I[2],card.I[3],card.I[4],
],

[  card.B[0], card.I[1],  card.B[4], card.I[3],card.G[1],
card.O[0], card.G[3],  card.O[4], 
card.N[0],card.N[1],card.N[2],card.N[3],card.N[4],
],

[  card.B[0], card.I[1],  card.B[4], card.I[3],card.G[1],
card.O[0], card.G[3],  card.O[4], 
card.G[0],card.G[1],card.G[2],card.G[3],card.G[4],
],

[   card.B[0], card.I[1],  card.B[4], card.I[3],card.G[1],
card.O[0], card.G[3],  card.O[4], 
card.O[0],card.O[1],card.O[2],card.O[3],card.O[4],
],

];



const AVERATH = [
  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2]
  ,card.B[0],card.B[1],card.B[2],card.B[3],card.B[4],],

  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2]
  ,card.I[0],card.I[1],card.I[2],card.I[3],card.I[4],],

  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2]
  ,card.N[0],card.N[1],card.N[2],card.N[3],card.N[4],],

  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2]
  ,card.G[0],card.G[1],card.G[2],card.G[3],card.G[4],],

  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2]
  ,card.O[0],card.O[1],card.O[2],card.O[3],card.O[4],],




  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.B[0],card.B[1],card.B[2],card.B[3],card.B[4],
], 
[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.I[0],card.I[1],card.I[2],card.I[3],card.I[4],
],
[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.N[0],card.N[1],card.N[2],card.N[3],card.N[4],
],
[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.G[0],card.G[1],card.G[2],card.G[3],card.G[4],
],
[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.O[0],card.O[1],card.O[2],card.O[3],card.O[4],
],


  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[0],card.B[1],card.B[2],card.B[3],card.B[4],
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.I[0],card.I[1],card.I[2],card.I[3],card.I[4],
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.N[0],card.N[1],card.N[2],card.N[3],card.N[4],
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.G[0],card.G[1],card.G[2],card.G[3],card.G[4],
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.O[0],card.O[1],card.O[2],card.O[3],card.O[4],
],
  





  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[0],card.B[1],card.B[2],card.B[3],card.B[4],
], 

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
card.I[0],card.I[1],card.I[2],card.I[3],card.I[4],
], 

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
card.N[0],card.N[1],card.N[2],card.N[3],card.N[4],
], 

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
card.G[0],card.G[1],card.G[2],card.G[3],card.G[4],
],
[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
card.O[0],card.O[1],card.O[2],card.O[3],card.O[4],
],



  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.B[0],card.B[1],card.B[2],card.B[3],card.B[4],
], 
[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.I[0],card.I[1],card.I[2],card.I[3],card.I[4],
], 
[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.N[0],card.N[1],card.N[2],card.N[3],card.N[4],
], 
[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.G[0],card.G[1],card.G[2],card.G[3],card.G[4],
], 
[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.O[0],card.O[1],card.O[2],card.O[3],card.O[4],
], 

 


  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.B[0],card.B[1],card.B[2],card.B[3],card.B[4],
], 

[card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.I[0],card.I[1],card.I[2],card.I[3],card.I[4],
],

[card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.N[0],card.N[1],card.N[2],card.N[3],card.N[4],
],

[card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.G[0],card.G[1],card.G[2],card.G[3],card.G[4],
],

[card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.O[0],card.O[1],card.O[2],card.O[3],card.O[4],
],


  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.B[0],card.B[1],card.B[2],card.B[3],card.B[4],],
  
  
  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.I[0],card.I[1],card.I[2],card.I[3],card.I[4],],
  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.N[0],card.N[1],card.N[2],card.N[3],card.N[4],],
  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.G[0],card.G[1],card.G[2],card.G[3],card.G[4],],
  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.O[0],card.O[1],card.O[2],card.O[3],card.O[4],],




  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[0],card.B[1],card.B[2],card.B[3],card.B[4],
], 

[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.I[0],card.I[1],card.I[2],card.I[3],card.I[4],
], 

[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.N[0],card.N[1],card.N[2],card.N[3],card.N[4],
], 

[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.G[0],card.G[1],card.G[2],card.G[3],card.G[4],
], 

[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.O[0],card.O[1],card.O[2],card.O[3],card.O[4],
], 





  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[0],card.B[1],card.B[2],card.B[3],card.B[4],], 

  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.I[0],card.I[1],card.I[2],card.I[3],card.I[4],], 

  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.N[0],card.N[1],card.N[2],card.N[3],card.N[4],], 

  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.G[0],card.G[1],card.G[2],card.G[3],card.G[4],], 

  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.O[0],card.O[1],card.O[2],card.O[3],card.O[4],], 

 // card.O[0],card.O[1],card.O[2],card.O[3],card.O[4],
// card.G[0],card.G[1],card.G[2],card.G[3],card.G[4],
// card.N[0],card.N[1],card.N[2],card.N[3],card.N[4],
// card.I[0],card.I[1],card.I[2],card.I[3],card.I[4],
// card.B[0],card.B[1],card.B[2],card.B[3],card.B[4],





  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[0],card.B[1],card.B[2],card.B[3],card.B[4],
], 
[card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
card.I[0],card.I[1],card.I[2],card.I[3],card.I[4],
], 
[card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
card.N[0],card.N[1],card.N[2],card.N[3],card.N[4],
], 
[card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
card.G[0],card.G[1],card.G[2],card.G[3],card.G[4],
], 
[card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
card.O[0],card.O[1],card.O[2],card.O[3],card.O[4],
], 


];

/// DIAGONAL

// [card.B[0], card.I[1], "Free", card.G[3], card.O[4]], 
//[card.O[0], card.G[1], "Free", card.I[3], card.B[4]] 
const ADATH=[

  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2]
  ,card.B[0], card.I[1], "Free", card.G[3], card.O[4]],

  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2]
  ,card.O[0], card.G[1], "Free", card.I[3], card.B[4]],

  




  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4]
], 
[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.O[0], card.G[1], "Free", card.I[3], card.B[4]
],



  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4]
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.O[0], card.G[1], "Free", card.I[3], card.B[4]
],


  





  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4]
], 

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
card.O[0], card.G[1], "Free", card.I[3], card.B[4]
], 





  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4]
], 
[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.O[0], card.G[1], "Free", card.I[3], card.B[4]
], 


 


  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4]
], 

[card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.O[0], card.G[1], "Free", card.I[3], card.B[4]
],




  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4]],
  
  
  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.O[0], card.G[1], "Free", card.I[3], card.B[4]],
  




  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4]
], 

[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.O[0], card.G[1], "Free", card.I[3], card.B[4]
], 






  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4]], 

  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.O[0], card.G[1], "Free", card.I[3], card.B[4]], 

  

  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4]
], 
[card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
card.O[0], card.G[1], "Free", card.I[3], card.B[4]
], 


];
//    card.B[0], card.I[1], "Free", card.G[3], card.O[4] 
//    card.O[0], card.G[1], "Free", card.I[3], card.B[4]
const ADATV=[
  [card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4] 

], 
[card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
  card.O[0], card.G[1], "Free", card.I[3], card.B[4]

],





[card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4],
card.B[0], card.I[1], "Free", card.G[3], card.O[4] 
],

[card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4],
card.O[0], card.G[1], "Free", card.I[3], card.B[4]
],


 



[card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
card.B[0], card.I[1], "Free", card.G[3], card.O[4] 
],

[card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
card.O[0], card.G[1], "Free", card.I[3], card.B[4]
],






[card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.B[0], card.I[1], "Free", card.G[3], card.O[4] 
], 


[card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.O[0], card.G[1], "Free", card.I[3], card.B[4]
], 






[ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
card.B[0], card.I[1], "Free", card.G[3], card.O[4] 
], 


[ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
card.O[0], card.G[1], "Free", card.I[3], card.B[4]
], 





  

[  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4] 
],


[  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
  card.O[0], card.G[1], "Free", card.I[3], card.B[4]
],





[ card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
card.B[0], card.I[1], "Free", card.G[3], card.O[4] 
], 


[ card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4],
card.O[0], card.G[1], "Free", card.I[3], card.B[4]
], 




[ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4] 
],

[ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
  card.O[0], card.G[1], "Free", card.I[3], card.B[4]
],







[ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.B[0], card.I[1], "Free", card.G[3], card.O[4] 
], 

[ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.O[0], card.G[1], "Free", card.I[3], card.B[4]
], 




[ card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.B[0], card.I[1], "Free", card.G[3], card.O[4] 
],

[ card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.O[0], card.G[1], "Free", card.I[3], card.B[4]
],

];
//card.O[0], card.G[1], "Free", card.I[3], card.B[4]
//card.B[0], card.I[1], "Free", card.G[3], card.O[4] 
const ADMS=[
  [ card.I[1],   card.I[3],card.G[1],
  card.G[3],
  card.O[0], card.G[1], "Free", card.I[3], card.B[4]
], 
[ card.I[1],   card.I[3],card.G[1],
  card.G[3],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4] 
], 

];


const ADCS=[
  [ card.B[0],  card.B[4], 
  card.O[0],   card.O[4],
  card.O[0], card.G[1], "Free", card.I[3], card.B[4]
], 
[ card.B[0],  card.B[4], 
card.O[0],   card.O[4],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4] 
], 

];


const ADFMC=[
  [ card.B[0], card.I[1],  card.B[4], card.I[3],card.G[1],
  card.O[0], card.G[3],  card.O[4],
  card.O[0], card.G[1], "Free", card.I[3], card.B[4]
], 
[ card.B[0], card.I[1],  card.B[4], card.I[3],card.G[1],
card.O[0], card.G[3],  card.O[4],
  card.B[0], card.I[1], "Free", card.G[3], card.O[4] 
], 

];



// [card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
//   card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]], 

//   [card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
///   card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4]], 

//   [card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
// /  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4]], 

//   [card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
///   card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]], 
  
//   [ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
///   card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]], 
  
//   [  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
///  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]], 

//   [ card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
///  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]], 

//   [ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
//   card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],], 

//   [ card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
//   card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]], 

//   [ card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],1 
//   card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]], 



const ATHATV=[
  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
  card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
   card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
],
[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
],
[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
   card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
],
[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
 card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
 card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
 card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
   card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
],


[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
   card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
   card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4]
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4]
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
],




  

  [card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
   card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
   card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
],
[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
 card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
],
[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
 card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
   card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
],
[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
 card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
 card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
 card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
 card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
 card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
 card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
   card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
],


[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
 card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
   card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
 card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
   card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4]
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
 card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4]
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
],






[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
],
[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
],
[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
],
[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
],


[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4]
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4]
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
],









[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
],
[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
],
[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
],
[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
],


[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4]
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4]
],

[card.B[0], card.I[0],  card.N[0], card.G[0],card.O[0],
card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
],
  

 




[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
   card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
],
[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
   card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
],
[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
   card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
],
[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
   card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
],

[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
   card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
],

[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
   card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
],


[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
   card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
],

[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
   card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4]
],

[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
   card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4]
],

[card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
   card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
],

   /////////////////// 
  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
  ],
  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
  ],
  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
  ],
  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
  ],
  
  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
  ],
  
  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
  ],
  
  
  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
  ],
  
  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4]
  ],
  
  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4]
  ],
  
  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
  ],
  // [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  // card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1]], 
  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
  ],
  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
  ],
  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
  ],
  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
  ],
  
  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
  ],
  
  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
  ],
  
  
  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
  ],
  
  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4]
  ],
  
  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4]
  ],
  
  [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
  ],
  // [card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  // card.B[1], card.I[1],  card.N[1], card.G[1],card.O[1]], 
  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
  ],
  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
  ],
  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
  ],
  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
  ],
  
  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
  ],
  
  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
  ],
  
  
  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
  ],
  
  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4]
  ],
  
  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4]
  ],
  
  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
  ],
  // [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  // card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3]], 
  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
  ],
  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
  ],
  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
  ],
  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
  ],
  
  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
  ],
  
  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
  ],
  
  
  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
  ],
  
  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4]
  ],
  
  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4]
  ],
  
  [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
  ],
  // [card.B[2], card.I[2],  card.N[2], card.G[2],card.O[2],
  // card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4]], 
  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
  ],
  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
  ],
  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4],
  ],
  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
  ],
  
  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
  ],
  
  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4], 
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
  ],
  
  
  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.O[0], card.O[1],  card.O[2], card.O[3],card.O[4]
  ],
  
  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.G[0], card.G[1],  card.G[2], card.G[3],card.G[4]
  ],
  
  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.N[0], card.N[1],  card.N[2], card.N[3],card.N[4]
  ],
  
  [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4],
  card.B[0], card.B[1],  card.B[2], card.B[3],card.B[4],
  card.I[0], card.I[1],  card.I[2], card.I[3],card.I[4]
  ],
  // [card.B[3], card.I[3],  card.N[3], card.G[3],card.O[3],
  // card.B[4], card.I[4],  card.N[4], card.G[4],card.O[4]],

];


if ((selectedPattern.value === 'anyhorizontal'  && selectedPattern2.value ==='anyvertical2')||(selectedPattern.value === 'anyvertical'  && selectedPattern2.value ==='anyhorizontal2')){
  for(const ahoraver of AHORAVER){
    if (isWinningPattern(ahoraver)) {
      bingoLine = ahoraver;
      break;
    }

  }

}


else if ((selectedPattern.value === 'anyhorizontal'  && selectedPattern2.value ==='anydiagonal2')||(selectedPattern.value === 'anydiagonal'  && selectedPattern2.value ==='anyhorizontal2')){
  for(const ahoradia of AHORADIA){
    if (isWinningPattern(ahoradia)) {
      bingoLine = ahoradia;
      break;
    }

  }

}


else if ((selectedPattern.value === 'anyhorizontal'  && selectedPattern2.value ==='anyTwoVertical2')||(selectedPattern.value === 'anyTwoVertical'  && selectedPattern2.value ==='anyhorizontal2')){
  for(const ahoratv of AHORATV){
    if (isWinningPattern(ahoratv)) {
      bingoLine = ahoratv;
      break;
    }

  }

}

else if ((selectedPattern.value === 'anyhorizontal'  && selectedPattern2.value ==='MS2')||(selectedPattern.value === 'MS'  && selectedPattern2.value ==='anyhorizontal2')){
  for(const ahorms of AHORMS){
    if (isWinningPattern(ahorms)) {
      bingoLine = ahorms;
      break;
    }

  }

}

else if ((selectedPattern.value === 'anyhorizontal'  && selectedPattern2.value ==='FMC2')||(selectedPattern.value === 'FMC'  && selectedPattern2.value ==='anyhorizontal2')){
  for(const ahorfmc of AHORFMC){
    if (isWinningPattern(ahorfmc)) {
      bingoLine = ahorfmc;
      break;
    }

  }

}

else if ((selectedPattern.value === 'anyhorizontal'  && selectedPattern2.value ==='CS2')||(selectedPattern.value === 'CS'  && selectedPattern2.value ==='anyhorizontal2')){
  for(const ahorcs of AHORCS){
    if (isWinningPattern(ahorcs)) {
      bingoLine = ahorcs;
      break;
    }

  }

}


//VERTICAL
else if ((selectedPattern.value === 'anyvertical'  && selectedPattern2.value ==='MS2')||(selectedPattern.value === 'MS'  && selectedPattern2.value ==='anyvertical2')){
  for(const averms of AVERMS){
    if (isWinningPattern(averms)) {
      bingoLine = averms;
      break;
    }

  }

}

else if ((selectedPattern.value === 'anyvertical'  && selectedPattern2.value ==='FMC2')||(selectedPattern.value === 'FMC'  && selectedPattern2.value ==='anyvertical2')){
  for(const averfmc of AVERFMC){
    if (isWinningPattern(averfmc)) {
      bingoLine = averfmc;
      break;
    }

  }

}

else if ((selectedPattern.value === 'anyvertical'  && selectedPattern2.value ==='CS2')||(selectedPattern.value === 'CS'  && selectedPattern2.value ==='anyvertical2')){
  for(const avercs of AVERCS){
    if (isWinningPattern(avercs)) {
      bingoLine = avercs;
      break;
    }

  }

}

else if ((selectedPattern.value === 'anyvertical'  && selectedPattern2.value ==='anydiagonal2')||(selectedPattern.value === 'anydiagonal'  && selectedPattern2.value ==='anyvertical2')){
  for(const averadia of AVERADIA){
    if (isWinningPattern(averadia)) {
      bingoLine = averadia;
      break;
    }

  }

}


else if ((selectedPattern.value === 'anyvertical'  && selectedPattern2.value ==='anyTwoHorizontal2')||(selectedPattern.value === 'anyTwoHorizontal'  && selectedPattern2.value ==='anyvertical2')){
  for(const averath of AVERATH){
    if (isWinningPattern(averath)) {
      bingoLine = averath;
      break;
    }

  }

}

//diagonal
else if ((selectedPattern.value === 'anydiagonal'  && selectedPattern2.value ==='anyTwoHorizontal2')||(selectedPattern.value === 'anyTwoHorizontal'  && selectedPattern2.value ==='anydiagonal2')){
  for(const adath of ADATH){
    if (isWinningPattern(adath)) {
      bingoLine = adath;
      break;
    }

  }

}

else if ((selectedPattern.value === 'anydiagonal'  && selectedPattern2.value ==='anyTwoVertical2')||(selectedPattern.value === 'anyTwoVertical'  && selectedPattern2.value ==='anydiagonal2')){
  for(const adatv of ADATV){
    if (isWinningPattern(adatv)) {
      bingoLine = adatv;
      break;
    }

  }

}

else if ((selectedPattern.value === 'anydiagonal'  && selectedPattern2.value ==='FMC2')||(selectedPattern.value === 'FMC'  && selectedPattern2.value ==='anydiagonal2')){
  for(const adfmc of ADFMC){
    if (isWinningPattern(adfmc)) {
      bingoLine = adfmc;
      break;
    }

  }

}

else if ((selectedPattern.value === 'anydiagonal'  && selectedPattern2.value ==='MS2')||(selectedPattern.value === 'MS'  && selectedPattern2.value ==='anydiagonal2')){
  for(const adms of ADMS){
    if (isWinningPattern(adms)) {
      bingoLine = adms;
      break;
    }

  }

}

else if ((selectedPattern.value === 'anydiagonal'  && selectedPattern2.value ==='CS2')||(selectedPattern.value === 'CS'  && selectedPattern2.value ==='anydiagonal2')){
  for(const adcs of ADCS){
    if (isWinningPattern(adcs)) {
      bingoLine = adcs;
      break;
    }

  }

}

else if ((selectedPattern.value === 'anyTwoHorizontal'  && selectedPattern2.value ==='anyTwoVertical2')||(selectedPattern.value === 'anyTwoVertical'  && selectedPattern2.value ==='anyTwoHorizontal2')){
  for(const athatv of ATHATV){
    if (isWinningPattern(athatv)) {
      bingoLine = athatv;
      break;
    }

  }

}
else if (selectedPattern.value === 'defaultPattern'  && selectedPattern2.value ==='defaultpattern2'){
 
  
    for (const line2 of lines2) {
      if (isWinningPattern(line2)) {
        bingoLine = line2;
        break;
      }
    }


}



else if (selectedPattern.value === 'anydiagonal'  && selectedPattern2.value ==='defaultpattern2'){
 
  
  for (const line3 of lines3) {
    if (isWinningPattern(line3)) {
      bingoLine = line3;
      break;
    }
  }


}



else if (selectedPattern.value === 'anyvertical'  && selectedPattern2.value ==='defaultpattern2'){
 
  
  for (const line4 of lines4) {
    if (isWinningPattern(line4)) {
      bingoLine = line4;
      break;
    }
  }


}








else if (selectedPattern.value === 'mark'  && selectedPattern2.value ==='defaultpattern2'){
    // This pattern requires the 'Mark2' square pattern AND any full line to be complete.

    // First, check if the 'Mark2' pattern is complete.
    const isMark2Complete = isWinningPattern(Mark2[0]);

    if (isMark2Complete) {
        // If the square is complete, now check for any complete line (row, column, or diagonal).
        for (const line of lines) {
            if (isWinningPattern(line)) {
                // If a line is also complete, we have a bingo.
                // The winning line is the combination of the square and the line.
                const combinedPattern = [...new Set([...Mark2[0], ...line])];
                bingoLine = combinedPattern;
                break; // Exit after finding the first complete line.
            }
        }
    }
}





else if ((selectedPattern.value === 'CS' && selectedPattern2.value === 'defaultpattern2') || (selectedPattern.value === 'defaultPattern' && selectedPattern2.value === 'CS2')) {
    // This pattern requires the 'CS4' (four corners) pattern AND any full line to be complete.

    // First, check if the 'CS4' pattern is complete.
    const isCS4Complete = isWinningPattern(CS4[0]);

    if (isCS4Complete) {
        // If the four corners are complete, now check for any complete line (row, column, or diagonal).
        for (const line of lines) {
            if (isWinningPattern(line)) {
                // If a line is also complete, we have a bingo.
                // The winning line is the combination of the four corners and the line.
                const combinedPattern = [...new Set([...CS4[0], ...line])];
                bingoLine = combinedPattern;
                break; // Exit after finding the first complete line.
            }
        }
    }
}
else if (selectedPattern.value === 'anyhorizontal'  && selectedPattern2.value ==='defaultpattern2'){
 
  
  for (const line5 of lines5) {
    if (isWinningPattern(line5)) {
      bingoLine = line5;
      break;
    }
  }


}


else{
    switch (selectedPattern.value) {
      case "atl": {
        const bingoResult = checkAnyThreeLines();
        if (bingoResult.isBingo) {
          bingoLine = Array.from(bingoResult.pattern);
        }
        break;
      }
      case "defaultPattern":
        // Check if any line matches the default winning pattern
        for (const line of lines) {
          if (isWinningPattern(line)) {
            bingoLine = line;
            break;
          }
        }
        break;


        case "aos":
        
          for (const aos of AOS) {
            if (isWinningPattern(aos)) {
              bingoLine = aos;
              break;
            }
          }
          break;

          case "mark":
        
          for (const mark of Mark) {
            if (isWinningPattern(mark)) {
              bingoLine = mark;
              break;
            }
          }
          break;

          case "ats":
            // Check if any line matches the default winning pattern
            for (const ats of ATS) {
              if (isWinningPattern(ats)) {
                bingoLine = ats;
                break;
              }
            }
            break;




  
      case "anyhorizontal":
        // Check only horizontal lines
        for (const row of rows) {
          if (isWinningPattern(row)) {
            bingoLine = row;
            break;
          }
        }
        break;

        
      case "MS":
        // Check only horizontal lines
        for (const ms4 of MS4) {
          if (isWinningPattern(ms4)) {
            bingoLine = ms4;
            break;
          }
        }
        break;

        case "CS":
          // Check only horizontal lines
          for (const cs4 of CS4) {
            if (isWinningPattern(cs4)) {
              bingoLine = cs4;
              break;
            }
          }
          break;
  
      case "anyvertical":
        // Check only vertical lines
        for (const column of columns) {
          if (isWinningPattern(column)) {
            bingoLine = column;
            break;
          }
        }
        break;
  
      case "anydiagonal":
        // Check only diagonal lines
        for (const diagonal of diagonals) {
          if (isWinningPattern(diagonal)) {
            bingoLine = diagonal;
            break;
          }
        }
        break;
  
      case "anyTwoLines":
        for (const atl of ATL) {
          if (isWinningPattern(atl)) {
            bingoLine = atl;
            break;
          }}
       
        break;
        case "anyTwoVertical": // New case for any two vertical lines
        for (const atv of ATV) {
          if (isWinningPattern(atv)) {
            bingoLine = atv;
            break;
          }}
       
        break;

        case "FMC": // New case for any two vertical lines
        for (const fmc of FMCC) {
          if (isWinningPattern(fmc)) {
            bingoLine = fmc;
            break;
          }}
       
        break;

        case "FullHouse": // New case for any two vertical lines
        for (const fh of FH) {
          if (isWinningPattern(fh)) {
            bingoLine = fh;
            break;
          }}
       
        break;
         // for (let i = 0; i < columns.length; i++) {
        //     for (let j = i + 1; j < columns.length; j++) {
        //         if (isWinningPattern(columns[i]) && isWinningPattern(columns[j])) {
        //             bingoLine = [columns[i], columns[j]];
        //             break;
        //         }
        //     }
        //     if (bingoLine) break;
        // }
        case "anyTwoHorizontal": // New case for any two horizontal lines
        for (const ath of ATH) {
          if (isWinningPattern(ath)) {
            bingoLine = ath;
            break;
          }}

    // for (let i = 0; i < rows.length; i++) {
    //     for (let j = i + 1; j < rows.length; j++) {
    //         if (isWinningPattern(rows[i]) && isWinningPattern(rows[j])) {
    //             bingoLine = [rows[i], rows[j]];
    //             break;
    //         }
    //     }
    //     if (bingoLine) break;
    // }
    break;
    case "letterA": // New case for letter A pattern
    for (const letterr of letterA) {
      if (isWinningPattern(letterr)) {
        bingoLine = letterr;
        break;
      }
    }
    
    // if (isWinningPattern(letterA[0]) && isWinningPattern(letterA[1])  
    //    ) {
    //     bingoLine = letterA;
    // }
    break;
  
      default:
        break;
    }
  }
    // Update state and sounds only when the winning line changes
    if (bingoLine) {
      const isNewWin = !arraysEqualAsSets(bingoLine, bingoNumbers);
      if (lastCalledBall && lastCalledBall.number != null) {
        const preferred = [...rows, ...columns, ...diagonals].find(
          (line) => isWinningPattern(line) && line.includes(lastCalledBall.number)
        );
        if (preferred) {
          bingoLine = preferred;
        }
      }
      if (isNewWin) {
        saveBingoData();
        playAudio(bingoLine); // Play winning audio for a new line only
      }
      // Keep bingo state true while a winning line exists
      setIsBingo(true);
      setBingoNumbers(bingoLine || []);
    } else {
      setIsBingo(false);
      playLoseAudio();
    }
  };

  const playAudio = (bingoLine) => {
    console.log('🎵 Playing win audio');
    if (performance.memory) {
      const memory = performance.memory;
      const usedMB = (memory.usedJSHeapSize / 1024 / 1024).toFixed(2);
      console.log(`📊 Audio Play Memory: ${usedMB} MB used`);
    }
    
    if (audioRef.current) {
      audioRef.current.currentTime = 0;
      setIsBingo(true);
      audioRef.current.play();
    }
  };

  const playLoseAudio = () => {
    console.log('🔇 Playing not-win audio');
    if (notWinAudioRef.current) {
      notWinAudioRef.current.currentTime = 0;
      notWinAudioRef.current.play();
    }
  };

  const saveBingoData = () => {
    setWinnerCards((prevWinnerCards) =>
      prevWinnerCards.includes(cartelaId)
        ? prevWinnerCards
        : [...prevWinnerCards, cartelaId]
    );
  };
  // const handleRefund=()=>{
  //   if(manualCut){
  //     alert('you have refunded '+totalAmount * (manualEnteredCut / 10)+'birr')
  //   }
  //   else{
  //     alert('you have refunded '+totalAmount * (manualEnteredCut / 100)+'birr')
  //   }
    
  // }

// Function to create and show the bonus modal
// function showBonusModal(bonusAmount, wonAmount) {
//   // Create modal elements
//   const modal = document.createElement('div');
//   const modalContent = document.createElement('div');
//   const closeButton = document.createElement('span');
//   const title = document.createElement('h2');
//   const message = document.createElement('p');

//   // Set up modal styles
//   modal.style.display = 'flex';
//   modal.style.justifyContent = 'center';
//   modal.style.alignItems = 'center';
//   modal.style.position = 'fixed';
//   modal.style.zIndex = '1000';
//   modal.style.left = '0';
//   modal.style.top = '0';
//   modal.style.width = '100%';
//   modal.style.height = '100%';
//   modal.style.backgroundColor = 'rgba(0, 0, 0, 0.4)';

//   // Set up content styles
//   modalContent.style.backgroundColor = '#fefefe';
//   modalContent.style.margin = 'auto';
//   modalContent.style.padding = '20px';
//   modalContent.style.border = '1px solid #888';
//   modalContent.style.width = '30%';
//   modalContent.style.position = 'relative';
//   modalContent.style.animation = 'popUp 0.5s ease-in-out';

//   // Close button styles
//   closeButton.innerHTML = '&times;';
//   closeButton.style.color = '#aaa';
//   closeButton.style.float = 'right';
//   closeButton.style.fontSize = '28px';
//   closeButton.style.fontWeight = 'bold';

//   // Title and message
//   title.innerText = "Congratulations!";
//   message.innerHTML = `The winner has won a bonus of <strong>${bonusAmount.toFixed(2)}</strong> (15% of <strong>${wonAmount.toFixed(2)}</strong>)`;

//   // Append elements
//   closeButton.onclick = function() {
//     document.body.removeChild(modal);
//     clearInterval(confettiInterval); // Stop confetti when closing the modal
//   };

//   closeButton.onmouseover = function() {
//     closeButton.style.color = "black";
//     closeButton.style.cursor = "pointer";
//   };

//   closeButton.onmouseout = function() {
//     closeButton.style.color = "#aaa";
//   };

//   modalContent.appendChild(closeButton);
//   modalContent.appendChild(title);
//   modalContent.appendChild(message);

//   // Append content to modal
//   modal.appendChild(modalContent);

//   // Append modal to body
//   document.body.appendChild(modal);

//    // Add confetti effect (optional)
//    let confettiInterval = setInterval(() => {
//      createConfetti(modalContent);
//    }, 200);
// }

// Function to create confetti effect
// function createConfetti(parent) {
//     const confettiPiece = document.createElement('div');
//     confettiPiece.classList.add('confetti');
//     confettiPiece.style.position = 'absolute';
//     confettiPiece.style.width = `${Math.random() * (15 - 5) + 5}px`;
//     confettiPiece.style.height = `${Math.random() * (15 - 5) + 5}px`;
//     confettiPiece.style.backgroundColor =
//         '#' + Math.floor(Math.random() * 16777215).toString(16); // Random color
//     confettiPiece.style.left = `${Math.random() * parent.offsetWidth}px`;
//     confettiPiece.style.top = `${Math.random() * parent.offsetHeight}px`;
//     parent.appendChild(confettiPiece);
    
//     setTimeout(() => {
//         parent.removeChild(confettiPiece);
//     }, Math.random() * (3000 - 1000) + 1000); // Remove after random time
// }

// Add CSS styles for the modal and animations dynamically
// const styleSheet = document.createElement("style");
// styleSheet.type = "text/css";
// styleSheet.innerText =
// `@keyframes popUp {
//     from { transform: scale(0.5); }
//     to { transform: scale(1); }
// }
// .confetti {
//     border-radius:50%;
// }`;
// document.head.appendChild(styleSheet);




  const handleRefund = async () => {
    // Calculate the refund amount
    const cutValue = manualCut ? Number(manualEnteredCut) : Number(currentUser.cut);
    const amountRefunded = manualCut ? totalAmount * (cutValue / 10) : totalAmount * (cutValue / 100);

    // Check if the calculated amount is valid
    if (!isNaN(amountRefunded) && amountRefunded > 0) {
        alert('This match does not count and is cancelled due to ' + cardCount + ' players salva!!! You have refunded ' + amountRefunded + ' birr');

        // Fetch current balance before updating
        try {
            const response = await axios.get(`/api/credit/${currentUser._id}/balance`);
            const currentBalance = response.data.balance;

            // Calculate the new balance
            const newBalance = currentBalance + amountRefunded;

            // Update the balance in the database
            await axios.put(`/api/user/${currentUser._id}/balance`, {
                balance: newBalance,
            });

            // Set refund status to true
            setIsRefunded(true); // Step 2: Update refund status

            alert(`Balance updated successfully! New balance: ${newBalance} birr`);
        } catch (error) {
            alert('There was an error fetching or updating the balance. Please try again.');
        }
    } else {
        alert('Invalid refund amount.');
    }
  };

  const handleEndGame = async () => {
    console.log('EndGame button clicked');
    console.log('isRefunded:', isRefunded);
    console.log('winnerCards:', winnerCards);
    
    // Step 3: Check if a refund has been processed
    if (isRefunded) {
        alert('The game has been refunded. ');
        setWinnerCards([]);
        resetLockedCards();
        onReset();
        onClose();
        return; // Prevent further execution if refunded
    }

    if (winnerCards.length === 0) {
        alert('No winners to save');
        return;
    }

    setIsSaving(true);
    const total = totalAmount;
    let cut, won;

    const bingoData = {
        bet: betAmount,
        player: cardCount,
        total: totalAmount,
        call: calledBalls.length,
        winner: winnerCards,
        branch: currentUser.branch,
        cashier: currentUser.username,
        date: new Date().toISOString(),
        balance: currentUser.balance,
    };

    if (manualCut) {
        cut = total * (manualEnteredCut / 10);
        won = total - cut;
        bingoData.cut = cut;
        bingoData.won = won;
    } else {
        cut = total * (currentUser.cut / 100);
        won = total - cut;
        bingoData.cut = cut;
        bingoData.won = won;
    }

    try {
        console.log('Sending bingo data:', bingoData);
        const response = await axios.post('/api/sales/sales', { winners: [bingoData] });
        console.log('API response:', response);

        if (response.status === 200) {
            console.log('API success - clearing state and closing modal');
            setWinnerCards([]);
            resetLockedCards();
            console.log('Calling onReset only...');
            onReset();
        } else {
            alert('Failed to save bingo data');
        }
    } catch (error) {
        console.error('Error saving bingo data:', error);
        alert('Error saving bingo data:', error);
    } finally {
        setIsSaving(false);
    }
  };


  // Calculate the bonus amount
  // const bonusPercentage = 0.15; // Bonus percentage of winning amount


  // if (won >= 500 && cardCount>=20) {
  //     bonusAmount = won * bonusPercentage;
  //     showBonusModal(bonusAmount, won); 
  //     bingoData.bonus=bonusAmount;

  //      // Show the bonus modal instead of alert

  //      try {
  //       const resp = await axios.get(`/api/credit/${currentUser._id}/balance`);
  //       const currentBalance = resp.data.balance; // Adjust based on your API response structure
  
  //       // Calculate the new balance
  //       const newBalance = currentBalance - bonusAmount ; // Assuming balance is stored in currentUser
  
  //       // Update the balance in the database
  //       await axios.put(`/api/user/${currentUser._id}/balance`, {
  //         balance: newBalance,
  //       });
  
        
  
  //       alert(`balance updated due to bonus! New balance: ${newBalance} birr`);
  //     } catch (error) {
  //       alert('There was an error fetching or updating the balance. Please try again.');
  //     }
  // }


  const handleLockCard = () => {
    const cartelaIdNumber = Number(cartelaId);
    
    // Check if the card is already locked
    if (lockedCards.includes(cartelaIdNumber)) {
      alert("This card is already locked.");
      return;
    }
  
    // Allow locking of the card if it's not already locked
    const newLockedCards = [...lockedCards, cartelaIdNumber];
    setLockedCards(newLockedCards);
    localStorage.setItem('lockedCards', JSON.stringify(newLockedCards));
    alert(`Card ${cartelaIdNumber} has been locked.`);
  };

  const resetLockedCards = () => {
    setLockedCards([]);
    localStorage.removeItem('lockedCards');
  };

  const handleCartelaIdChange = (event) => {
    setCartelaId(event.target.value);
  };

  // Handle key down events
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      fetchCartela();
    }
  };

  return (
    <div>
      <div className="modal" style={{ 
        top: cartela && cartela.length > 0 ? '1%' : '20%', 
        transform: 'translateX(-50%)', 
        display: 'flex', 
        flexDirection: 'column', 
        minHeight: cartela && cartela.length > 0 ? '700px' : '300px', 
        maxHeight: '90vh', 
        overflow: 'auto',
        transition: 'all 0.3s ease-in-out' // Smooth transition
      }}>
        <h4 className="margin-md">Enter Cartela ID</h4>
        <input
          type="text"
          placeholder="Enter cartela id"
          value={cartelaId}
          onChange={handleCartelaIdChange} // This updates the cartelaId state
          onKeyDown={handleKeyDown}
          ref={inputRef}
        />
        <div className="action-row" style={{display:'flex',gap:'8px',justifyContent:'center',marginTop:'8px'}}>
        <button onClick={fetchCartela} disabled={isFetching}>
          {isFetching ? 'Checking...' : 'Check'}
        </button>
        <button onClick={handleLockCard} disabled={!cartela }>Lock <FaLock /> </button>
        </div>

        {fetchError && <div className="error">{fetchError}</div>}
        {cartela && cartela.length > 0 && cartela[0].card && (
          <div>
            <h4 className="margin-md">Cartela Numbers</h4>
            <div>
              {/* Column headers */}
              <div className="cartela-headers">
                {['B', 'I', 'N', 'G', 'O'].map(column => (
                  <h5 key={column}>{column}</h5>
                ))}
              </div>
              
              {/* 5x5 Grid */}
              <div className="cartela-grid">
                {[0, 1, 2, 3, 4].map(rowIndex => 
                  ['B', 'I', 'N', 'G', 'O'].map(column => {
                    const number = cartela[0].card[column][rowIndex];
                    const isBingoNumber = bingoNumbers.includes(number);
                    const isFreeSpace = column === 'N' && rowIndex === 2;

                    // Only show matched numbers if there is no bingo yet
                    const isMatched = !isBingo && matchedNumbers.some(
                      (call) => call.number === number
                    );

                    const cellClasses = [
                      isFreeSpace ? 'free-space' : '',
                      (isBingoNumber || isFreeSpace) ? 'bingo-number' : '',
                      isMatched ? 'matched' : '',
                    ].join(' ').trim();

                    return (
                      <div
                        key={`${column}-${rowIndex}`}
                        className={cellClasses}
                      >
                        {isFreeSpace ? "Free" : number}
                      </div>
                    );
                  })
                ).flat()}
              </div>
            </div>
            {isBingo && (
              <div className="winner-announcement" style={{
                textAlign: 'center',
                padding: '1px',
                backgroundColor: '#4CAF50',
                color: 'white',
                borderRadius: '8px',
                margin: '10px 0',
                boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                animation: 'pulse 2s infinite',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px'
              }}>
                <FaCheckCircle style={{ color: '#fff', fontSize: '18px' }} />
                <span style={{ fontSize: '18px', fontWeight: 'bold' }}>WINNER!</span>
                <span style={{ fontSize: '16px' }}>🎉</span>
              </div>
            )}
          </div>
        )}
        <div style={{ marginTop: 'auto', textAlign: 'center' }}>
          {cartelaId && (
            <span className="text-lg ml-4">Card ID: {cartelaId}</span>
          )}
          <button onClick={onClose} > continue <ImExit/></button>
          <button onClick={handleEndGame} disabled={winnerCards.length === 0 || isSaving}>{isSaving? (<l-newtons-cradle
  size="78"
  speed="1.4" 
  color="black"   
></l-newtons-cradle>): ('EndGame')} </button>
          <button onClick={handleRefund} disabled={winnerCards.length <3}>Refund </button>
        </div>
      </div>
      <div className="modal-backdrop" onClick={onClose}></div>
    </div>
  );
};

export default CartelaModal;